module.exports = __webpack_public_path__ + "static/media/gallery-2.e77d42cf.png";